export default __webpack_public_path__ + "static/media/glsl_ray_tracing.1cfc4f8a.pdf";